import { render } from "./Media.vue?vue&type=template&id=91735e74&scoped=true&ts=true"
import script from "./Media.vue?vue&type=script&lang=ts"
export * from "./Media.vue?vue&type=script&lang=ts"

import "./Media.vue?vue&type=style&index=0&id=91735e74&scoped=true&lang=css"

import exportComponent from "/home/quangphuc/s-tech/admin-nhaongay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91735e74"]])

export default __exports__